import base from "/vercel/path0/images/pause-large.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");